import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";

// Import the specific static content for Celebrations
import { celebrationEventContent } from "./CelebrationEventContent";

// Import placeholder components for sub-tabs
import CelebrationDetailsTab from "./CelebrationDetailsTab";
import CelebrationActivitiesTab from "./CelebrationActivitiesTab";
import CelebrationSpeechTab from "./CelebrationSpeechTab";
import CelebrationProjectsTab from "./CelebrationProjectsTab";

// Thunks + store
import {
  fetchHolidaysThunk,
  fetchSessionsThunk,
  fetchEventsThunk,
  fetchCompetitionsThunk,
  fetchExamsThunk,
  fetchPtmsThunk,
  fetchCelebrationsThunk,
  fetchAwarenessThunk,
} from "../../redux/academicCalendarSlice";
import userStore from "../../../../zustand/userStore";

const CelebrationDetailsPage = () => {
  const { idOrDate } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = userStore((state) => state.user);

  const academicCalendarData = useSelector(
    (state) => state.academicCalendar.academicData
  );
  const [eventItem, setEventItem] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("details");

  const [currentEventContent, setCurrentEventContent] = useState(null);

  useEffect(() => {
    if (academicCalendarData.length === 0 && userData.id) {
      setIsLoading(true);
      dispatch(fetchHolidaysThunk({ user_id: userData.id }));
      dispatch(fetchSessionsThunk());
      dispatch(fetchEventsThunk());
      dispatch(fetchCompetitionsThunk({ user_id: userData.id }));
      dispatch(fetchExamsThunk({ user_id: userData.id }));
      dispatch(fetchPtmsThunk({ user_id: userData.id }));
      dispatch(fetchCelebrationsThunk({ user_id: userData.id }));
      dispatch(fetchAwarenessThunk({ user_id: userData.id }));
      return;
    }

    if (academicCalendarData.length > 0) {
      const foundItem = academicCalendarData.find((item) => {
        if (item.type === "celebration") {
          const idMatch = String(item.celebration_id || item.id) === String(idOrDate);
          const dateMatch =
            item.start_date &&
            moment(item.start_date).format("YYYY-MM-DD") === idOrDate;
          return idMatch || dateMatch;
        }
        return false;
      });

      setEventItem(foundItem);
      setIsLoading(false);

      if (foundItem) {
        const eventDateKey = moment(foundItem.start_date).format("MM-DD");
        setCurrentEventContent(celebrationEventContent[eventDateKey] || null);
      } else {
        setCurrentEventContent(null);
      }
    }
  }, [idOrDate, academicCalendarData, dispatch, userData.id]);

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "80vh" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!eventItem) {
    return (
      <div className="alert alert-warning text-center" role="alert" style={{ margin: "20px" }}>
        Celebration not found for: {idOrDate}
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <div className="d-flex gap-3 align-items-center mb-3">
        <button className="btn btn-primary" onClick={() => navigate(-1)}>
          Go Back
        </button>
        <h2 className="text-primary m-0 text-18">
          {eventItem.name || eventItem.details}
        </h2>
      </div>

      {/* Nav tabs same as Awareness page */}
       <div className="d-flex gap-3 mb-2">
          <button
            className={`btn  ${activeTab === "details" ? "active btn-primary" : "btn-light"}`}
            onClick={() => setActiveTab("details")}
          >
            Details
          </button>
         
          <button
            className={`btn  ${activeTab === "activities" ? "active btn-primary" : "btn-light"}`}
            onClick={() => setActiveTab("activities")}
          >
            Activities
          </button>
        
          <button
            className={`btn  ${activeTab === "speech" ? "active btn-primary" : "btn-light"}`}
            onClick={() => setActiveTab("speech")}
          >
            Speech
          </button>
        
          <button
            className={`btn  ${activeTab === "projects" ? "active btn-primary" : "btn-light"}`}
            onClick={() => setActiveTab("projects")}
          >
            List of Projects
          </button>
         </div>

      <div className="tab-content">
        {activeTab === "details" && (
          <CelebrationDetailsTab item={eventItem} eventContent={currentEventContent?.details} />
        )}
        {activeTab === "activities" && (
          <CelebrationActivitiesTab item={eventItem} eventContent={currentEventContent?.activities} />
        )}
        {activeTab === "speech" && (
          <CelebrationSpeechTab item={eventItem} eventContent={currentEventContent?.speeches} />
        )}
        {activeTab === "projects" && (
          <CelebrationProjectsTab item={eventItem} eventContent={currentEventContent?.projects} />
        )}
      </div>
    </div>
  );
};

export default CelebrationDetailsPage;
